import { Component } from 'react';
import { withRouter } from "react-router-dom"

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
            const navBtn = document.getElementById("collapsedNavBtn")
            if (navBtn) {
                if (navBtn.className.indexOf("collapsed") === -1) {
                    navBtn.className += " collapsed";
                }
                navBtn.setAttribute("aria-expanded", "false");
            }

            const navBar = document.getElementById("navbarCollapse")
            if (navBar) {
                if (navBar.className.indexOf("collapsed") === -1) {
                    navBar.className += " collapsed";
                }
                if (navBar.className.indexOf("show") > 1) {
                    navBar.className = navBar.className.replace(" show", "");
                }
                navBar.setAttribute("aria-expanded", "false");
            }
        }
    }

    render() {
        return this.props.children
    }
}

export default withRouter(ScrollToTop)


// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js